import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 7l10 10","key":"svg-0"}],["path",{"d":"M16 7l-9 0l0 9","key":"svg-1"}]]

/**
 * IconArrowUpLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctdXAtbGVmdCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNyA3bDEwIDEwIiAvPgogIDxwYXRoIGQ9Ik0xNiA3bC05IDBsMCA5IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrow-up-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowUpLeft = createReactComponent('outline', 'arrow-up-left', 'ArrowUpLeft', __iconNode);

export default IconArrowUpLeft;